import React from "react";
import useImg from "../images/avatar.jpg";

const Sideabar = () => {
  return (
    <aside className="sidebar">
      {/* -------------- header */}
      <div className="sidebar-header">
        <div className="img-div">
          <img className="user-img" src={useImg} />
        </div>
        <h3>Axel Reid</h3>
        <p>Fron-end Web Developer</p>
      </div>
      <div className="two">
        {/* -------------- Info */}
        <div className="sidebar-info">
          <div>
            <h4>Residence:</h4>
            <p>Uzbekistan</p>
          </div>
          <div>
            <h4>Cit(y/ies):</h4>
            <p>Andijan, Tashkent</p>
          </div>
          <div>
            <h4>Age:</h4>
            <p>{new Date().getFullYear() - 2000}</p>
          </div>
        </div>
        {/* -------------- svg circle */}
        <div className="svgs-lengua">
          <div className="svg uzbek">
            <svg>
              <circle cx="30" cy="30" r="30"></circle>
              <circle cx="30" cy="30" r="30"></circle>
            </svg>
            <div>
              <h4>100%</h4>
            </div>
            <p>Uzbek</p>
          </div>
          <div className="svg english">
            <svg>
              <circle cx="30" cy="30" r="30"></circle>
              <circle cx="30" cy="30" r="30"></circle>
            </svg>
            <div>
              <h4>90%</h4>
            </div>
            <p>English</p>
          </div>
          <div className="svg spanish">
            <svg>
              <circle cx="30" cy="30" r="30"></circle>
              <circle cx="30" cy="30" r="30"></circle>
            </svg>
            <div>
              <h4>30%</h4>
            </div>
            <p>Spanish</p>
          </div>
        </div>
      </div>
      {/* -------------- skills */}
      <div className="skills">
        <div className="skill html">
          <div className="skill-texts">
            <h4>html</h4>
            <p>90%</p>
          </div>
          <div className="progress h">
            <span></span>
          </div>
        </div>
        {/* -------------- skill css */}
        <div className="skill css">
          <div className="skill-texts">
            <h4>css, scss</h4>
            <p>93%</p>
          </div>
          <div className="progress c">
            <span></span>
          </div>
        </div>
        {/* -------------- skill js */}
        <div className="skill js">
          <div className="skill-texts">
            <h4>js, (react js)</h4>
            <p>85%</p>
          </div>
          <div className="progress j">
            <span></span>
          </div>
        </div>
        {/* -------------- skill responsive design  */}
        <div className="skill design">
          <div className="skill-texts">
            <h4>responsive design</h4>
            <p>90%</p>
          </div>
          <div className="progress r-d">
            <span></span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sideabar;
